import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { addContratista, addEmpresa, editContratista, editEmpresa, getCIIU, sendAllResForm, } from "../../../../redux/actions/resolucion";
import { convertDateTimeToNet, convertDateToNet, } from "../../../../util/datetime";
import { downloadFile } from "../../../../util/files";
import CircularLoading from "../../../commons/loading/CircularLoading";
import { StyledResolucion } from "../../../styled/Prevencion";
import DialogComponent from "./DialogComponent";
import TableComponent from "./TableComponent";

const ContratistasYEmpresasContainer = ({
  handleCancelResolucion,
  nextForm,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();

  const contratistas = useSelector((state) => state.resolucion.contratistas);
  const empresas = useSelector((state) => state.resolucion.empresas);
  const res81Data = useSelector((state) => state.resolucion.postResolucion);
  const idDependenciaEmpleador = useSelector(
    (state) => state.resolucion.searchedEstablecimiento
  );
  const datosEstablecimiento = useSelector(
    (state) => state.resolucion.datosEstablecimiento.data
  );
  const loadingPostAllRes = useSelector(
    (state) => state.resolucion.postAllRes.loading
  );
  const [openDialogContratista, setOpenDialogContratista] = useState(false);
  const [openDialogEmpresa, setOpenDialogEmpresa] = useState(false);
  const [editData, setEditData] = useState(null);

  useEffect(() => {
    dispatch(getCIIU());
  }, []);

  // Métodos para abrir y cerrar diálogos
  const handleOpenContratistaDialog = (data = null) => {
    setEditData(data);
    setOpenDialogContratista(true);
  };

  const handleOpenEmpresaDialog = (data = null) => {
    setEditData(data);
    setOpenDialogEmpresa(true);
  };

  const handleCloseDialog = () => {
    setEditData(null);
    setOpenDialogContratista(false);
    setOpenDialogEmpresa(false);
  };

  const handleSubmitContratista = (values) => {
    dispatch(addContratista(values));
  };

  const handleSubmitEmpresa = (values) => {
    dispatch(addEmpresa(values));
  };

  const handleEditContratista = (values) => {
    dispatch(editContratista(values));
  };

  const handleEditEmpresas = (values) => {
    dispatch(editEmpresa(values));
  };

  const postFinalCancerigenos = () => {
    let payload = {
      // Dependencia empleador
      idDependenciaEmpleador: idDependenciaEmpleador,
      ...(state?.idFormulario && {
        id: state?.idFormulario
      }),
      // Cabecera
      totalTrabajadoresProduccion:
        res81Data.cabecera.cantidadTrabajadoresProduccion,
      totalTrabajadoresProduccionEventuales:
        res81Data.cabecera.cantidadTrabajadoresEventualesProduccion,
      totalTrabajadoresAdministracion:
        res81Data.cabecera.cantidadTrabajadoresAdministracion,
      totalTrabajadoresAdministracionEventuales:
        res81Data.cabecera.cantidadTrabajadoresEventualesAdministracion,
      permiteFumar: res81Data.cabecera.sePuedeFumar,
      poseeEspacioFumador: res81Data.cabecera.espacioParaFumar,
      idContactoEmpresa: res81Data.cabecera.contacto,
      idResponsableEmpresa: res81Data.cabecera.responsableEmpresa,
      idResponsableEmpresaML: res81Data.cabecera.responsableMedicina,
      idResponsableEmpresaSH: res81Data.cabecera.responsableSH,
      idEstablecimientoDeclaradoSRT: res81Data.cabecera.idEstablecimientoDeclaradoSRT,

      // Observaciones:

      observacionesGenerales: res81Data.observaciones.observacionesGenerales,
      descripcionActividad:
        res81Data.observaciones.descripcionActividadEstablecimiento,

      // Sustancias y puestos:

      sustancias: res81Data.sustancias.map((sustancia) => {
        let proveedoresCompradores = sustancia.proveedores.map((proveedor) => ({
          ...(state?.idFormulario && {
            id: proveedor.idPrevForm,
          }),
          razonSocial: proveedor.razonSocial,
          cuit: proveedor.cuit,
          pais: proveedor.pais,
          esComprador: proveedor.esComprador,
          provincia: proveedor.provincia,
          localidad: proveedor.localidad,
          calle: proveedor.calle,
          nro: proveedor.numero,
          piso: proveedor.piso,
          departamento: proveedor.departamento,
          sinNro: false,
          codigoPostal: proveedor.codigoPostal,
          telefono: "",
          codigoSRT: proveedor.codigoSRT,
        }));

        let utilizaciones = sustancia.usos.map((uso) => ({
          ...(state?.idFormulario && {
            id: uso.idPrevForm,
          }),
          idUsoOrigen: uso.usos,
          idModoEmpleo: uso.modoEmpleo,
          codigoSRT: uso.codigoSRT,
        }));

        let estudios = sustancia.estudios.map((estudio) => ({
          ...(state?.idFormulario && {
            id: estudio.idPrevForm,
          }),
          idTipoEstudio: estudio.idTipoEstudio,
          cantidadFrecuencia: estudio.numeroFrecuencia,
          idFrecuenciaEstudio: estudio.frecuenciaEstudio,
          idMetodologiaEmpleada: estudio.idMetodologiaEmpleada,
          codigoSRT: estudio.codigoSRT,
        }));

        let equiposRadiologicos = sustancia.equiposRadiologicos.map(
          (equipoRadiologico) => ({
            ...(state?.idFormulario && {
              id: equipoRadiologico.equipoRadiologicoData.idPrevForm,
            }),
            idEquipoRadiologicoEstablecimiento:
              equipoRadiologico.equipoRadiologicoData.id,
            idEquipoRadiologicoSRT: equipoRadiologico.equipoRadiologicoData.idEquipoRadiologicoSRT,
            dosimetrias: equipoRadiologico.dosimetria.map((dosimetria) => ({
              ...(state?.idFormulario && {
                id: dosimetria.idPrevForm,
              }),
              idTipoDosimetria: dosimetria.tipoDosimetria,
              idMetodoDosimetria: dosimetria.metodoDosimetria,
              cantidadPersonal: dosimetria.cantidadPersonal,
              cuitResponsable: dosimetria.cuitResponsable,
              codigoSRT: dosimetria.codigoSRT,
            })),

            responsablesUso: equipoRadiologico.respUso.map((responsable) => ({
              ...(state?.idFormulario && {
                id: responsable.idPrevForm,
              }),
              numeroPermisoHabilitante: responsable.numeroPermisoHabilitante,
              matriculaProfesional: responsable.matriculaProfesional,
              numeroAutorizacionIndividual:
                responsable.numeroAutorizacionIndividual,
              cuitResponsable: responsable.cuitResponsable,
              fechaExpedicion: convertDateTimeToNet(
                responsable.fechaExpedicion
              ),
              fechaVencimiento: convertDateTimeToNet(
                responsable.fechaVencimiento
              ),
              licenciaEspecial: responsable.licenciaEspecial,
              codigoSRT: responsable.codigoSRT,
            })),

            responsablesInstalacion: equipoRadiologico.respInst.map(
              (responsable) => ({
                ...(state?.idFormulario && {
                  id: responsable.idPrevForm,
                }),
                numeroLicenciaHabilitante:
                  responsable.numeroLicenciaHabilitante,
                domicilioHabilitacion: responsable.domicilioHabilitacion,
                cuitResponsable: responsable.cuitResponsable,
                fechaExpedicion: convertDateTimeToNet(
                  responsable.fechaExpedicion
                ),
                fechaVencimiento: convertDateTimeToNet(
                  responsable.fechaVencimiento
                ),
                codigoSRT: responsable.codigoSRT,
              })
            ),
            encargadosProteccion: equipoRadiologico.protRad.map(
              (responsable) => ({
                ...(state?.idFormulario && {
                  id: responsable.idPrevForm,
                }),
                cuitResponsable: responsable.cuitResponsable,
                matriculaProfesional: responsable.matriculaProfesional,
                tituloProfesional: responsable.tituloProfesional,
                numeroHabilitacion: responsable.numeroHabilitacion,
                codigoSRT: responsable.codigoSRT,
              })
            ),
          })
        );

        let puestos = res81Data.puestos
          .filter((p) => p.sustancia === sustancia.id)
          .map((puesto) => {
            // Mapeo de puestos
            return {
              ...(state?.idFormulario && {
                id: puesto.idPrevForm,
              }),
              idPuestoEstablecimiento: puesto.puesto,
              descripcion: puesto.descripcionActividades,
              informaSobreRiesgos: puesto.informaRiesgos,
              capacitacionSobreRiesgos: puesto.poseeCapacitaciones,
              entregaElementosDeProteccion: puesto.entregaProteccion,
              licenciaEspecial: puesto.licenciasEspeciales,
              descripcionEstudios: puesto.descripcionEstudios,
              elementosProteccionPersonal: puesto.elementosDeProteccion.map(
                (elementoDeProteccion) => ({
                  ...(state?.idFormulario && {
                    id: elementoDeProteccion.idPrevForm,
                  }),
                  idElementoProteccionPersonal:
                    elementoDeProteccion.idElementoDeProteccion,
                })
              ),
              medidasPreventivas: puesto.medidasPreventivas.map(
                (medidaPreventiva) => ({
                  ...(state?.idFormulario && {
                    id: medidaPreventiva.idPrevForm,
                  }),
                  idMedidaPreventivaCancerigenos:
                    medidaPreventiva.idMedidaPreventiva,
                })
              ),
              codigoSRT: puesto.codigoSRT,
            };
          });

        return {
          ...(state?.idFormulario && {
            id: sustancia.idPrevForm,
          }),
          idSustancia: parseInt(sustancia.id),
          idAgenteCancerigeno: sustancia.sustancia.sustancia,
          nombreComercial: sustancia.sustancia.nombre,
          cantidad: parseFloat(sustancia.sustancia.cantidad.replace(",", ".")),
          idUnidadMedida: sustancia.sustancia.unidad,
          codigoSRT: sustancia.codigoSRT,
          proveedoresCompradores,
          utilizaciones,
          estudios,
          equiposRadiologicos,
          puestos,
        };
      }),
      // Trabajadores:
      trabajadores: res81Data.trabajadores.map((trabajador) => {
        let trabajadorPost = {
          ...(state?.idFormulario && {
            id: trabajador.idPrevForm,
          }),
          cuitNomina: trabajador.cuil,
          nombreCompletoNomina: trabajador.nombreApellidoTrabajador,
          idNomina: trabajador.idTrabajador,
          fechaIngresoEmpresa: convertDateToNet(trabajador.fechaIngreso),
          idPuestoEstablecimiento: trabajador.idPuesto,
          idSectorEstablecimiento: trabajador.idSector,
          fechaInicioContacto: convertDateToNet(trabajador.inicioContacto),
          fechaFinContacto: convertDateToNet(trabajador.finContacto),
          sinExposicion: trabajador.exposicion,
          permanente: trabajador.permanente,
          examenesMedicos: [],
          codigoSRT: trabajador.codigoSRT,
          codigoActividadSRT: trabajador.codigoActividadSRT,
        };
        Object.keys(trabajador?.examenes).forEach((sustanciaExamenes) => {
          Object.keys(trabajador?.examenes[sustanciaExamenes]).forEach(
            (idExamen) => {
              if (trabajador?.examenes[sustanciaExamenes][idExamen]?.value) {
                trabajadorPost.examenesMedicos.push({
                  ...(state?.idFormulario && {
                    id: trabajador?.examenes[sustanciaExamenes][idExamen]?.idPrevForm,
                  }),
                  idTipoExamenMedico: parseInt(idExamen),
                  idSustancia: parseInt(sustanciaExamenes),
                  idExamenDeclaradoSRT: trabajador?.examenes[sustanciaExamenes][idExamen]?.idExamenDeclaradoSRT
                });
              }
            }
          );
        });
        return trabajadorPost;
      }),

      // Contratistas:
      contratistas: contratistas.data.map((contratista) => ({
        ...(state?.idFormulario && {
          id: contratista.idPrevForm,
        }),
        cuit: contratista.cuit,
        actividad: contratista.ciiu,
        cantidadTrabajadores: contratista.cantidadEmpleados,
        idContratistaSRT: contratista.idContratistaSRT,
      })),

      // Empresas:
      empresasTercerizadas: empresas.data.map((contratista) => ({
        ...(state?.idFormulario && {
          id: contratista.idPrevForm,
        }),
        cuit: contratista.cuit,
        actividad: contratista.ciiu,
        cantidadTrabajadores: contratista.cantidadEmpleados,
        idEmpresaSRT: contratista.idEmpresaSRT,
      })),
    };

    dispatch(sendAllResForm(payload)).then((res) => {
      // En caso de edicion el no hay pdf a descargar. Ya que se presento anteriormente
      if (res?.value?.fileName) {
        downloadFile(res?.value?.data, res.value.fileName);
      }

      toast.success("Formulario Resolución 81/19 enviado exitosamente");
      navigate(`/prevencion/establecimientos/${idDependenciaEmpleador}`, {
        state: {
          ...datosEstablecimiento,
          idDependenciaEmpleador,
        },
      });
    });
  };

  return (
    <>
      <StyledResolucion.Container>
        {loadingPostAllRes ? (
          <CircularLoading />
        ) : (
          <>
            <TableComponent
              onAdd={() => handleOpenContratistaDialog()}
              onEdit={handleOpenContratistaDialog}
              data={contratistas.data}
              title="Contratista"
            />
            <TableComponent
              onAdd={() => handleOpenEmpresaDialog()}
              onEdit={handleOpenEmpresaDialog}
              data={empresas.data}
              title="Empresa Tercerizada"
            />
            {/* Diálogos */}
            <DialogComponent
              open={openDialogContratista}
              onClose={handleCloseDialog}
              onSubmit={handleSubmitContratista}
              onEdit={handleEditContratista}
              editData={editData}
              title="Contratista"
            />
            <DialogComponent
              open={openDialogEmpresa}
              onClose={handleCloseDialog}
              onSubmit={handleSubmitEmpresa}
              onEdit={handleEditEmpresas}
              editData={editData}
              title="Empresa Tercerizada"
            />
          </>
        )}
      </StyledResolucion.Container>
      <StyledResolucion.ButtonContainer style={{ margin: "10px", width: "auto" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => postFinalCancerigenos()}
          disabled={loadingPostAllRes}
        >
          Finalizar
        </Button>
      </StyledResolucion.ButtonContainer>
    </>
  );
};

export default ContratistasYEmpresasContainer;
